import axios from "axios";

// Criar nova playlist
export const createPlaylist = async (playlistData, token) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/createPlaylist`,
      playlistData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Erro ao criar playlist" };
  }
};

// Obter playlist por ID
export const getPlaylist = async (playlistId, token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getPlaylist/${playlistId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Erro ao buscar playlist" };
  }
};

// Obter playlists de um usuário
export const getUserPlaylists = async (username, token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getUserPlaylists/${username}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Erro ao buscar playlists" };
  }
};

// Obter minhas playlists
export const getMyPlaylists = async (token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getMyPlaylists`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Erro ao buscar playlists" };
  }
};

// Atualizar playlist
export const updatePlaylist = async (playlistId, playlistData, token) => {
  try {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/updatePlaylist/${playlistId}`,
      playlistData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Erro ao atualizar playlist" };
  }
};

// Deletar playlist
export const deletePlaylist = async (playlistId, token) => {
  try {
    await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/deletePlaylist/${playlistId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", message: "Playlist deletada com sucesso" };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Erro ao deletar playlist" };
  }
};

// Adicionar item à playlist
export const addPlaylistItem = async (playlistId, itemData, token) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/addPlaylistItem/${playlistId}`,
      itemData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Erro ao adicionar item" };
  }
};

// Remover item da playlist
export const removePlaylistItem = async (playlistId, itemId, token) => {
  try {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/removePlaylistItem/${playlistId}/${itemId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Erro ao remover item" };
  }
};

// Reordenar itens da playlist
export const reorderPlaylistItems = async (playlistId, itemOrders, token) => {
  try {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/reorderPlaylistItems/${playlistId}`,
      { itemOrders },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Erro ao reordenar itens" };
  }
};

// Registrar visualização
export const viewPlaylist = async (playlistId, token) => {
  try {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/viewPlaylist/${playlistId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Erro ao registrar visualização" };
  }
};

// Salvar/remover playlist dos salvos
export const savePlaylist = async (playlistId, token) => {
  try {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/savePlaylist/${playlistId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Erro ao salvar playlist" };
  }
};

// Obter playlists salvas
export const getSavedPlaylists = async (token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getSavedPlaylists`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Erro ao buscar playlists salvas" };
  }
};

// Obter playlists públicas (descobrir)
export const getPublicPlaylists = async (token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getPublicPlaylists`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Erro ao buscar playlists públicas" };
  }
};

// Obter vídeos disponíveis para adicionar
export const getAvailableVideos = async (token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getAvailableVideos`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Erro ao buscar vídeos disponíveis" };
  }
};
